angular.module('rjmNg.controllers').controller('editEmailSummaryCtrl', [
  "$scope"
  "$resource"
  "$routeParams"
  "$url"
  "EmailSummaries"
  "app"
  "Charts"
  "$q"
  "emailSummaryEnums"
  "$location"
  "$clientAppUrl"
  "appRoute"
  (
    $scope
    $resource
    $routeParams
    $url
    EmailSummaries
    app
    Charts
    $q
    emailSummaryEnums
    $location
    $clientAppUrl
    appRoute
  ) ->

    $scope.emailSummaryUrl = $clientAppUrl('/settings/emailsummary')

    $scope.app = app
    $scope.emailSummaryEnums = emailSummaryEnums
    $scope.esumAction = $routeParams.esumAction
    $scope.hours = []
    $scope.frequencies = []

    # make this usable for ngRepeat
    for id of emailSummaryEnums.HOURS
      $scope.hours.push( { id: id, name: emailSummaryEnums.HOURS[id] })
    for id of emailSummaryEnums.FREQUENCIES
      $scope.frequencies.push( { id: id, name: emailSummaryEnums.FREQUENCIES[id] } )

    # An array of objects, containing all relevant email addresses (all users associated with this
    # client and all addresses included in other bcc's for this user) and whether they have been
    # selected as a bcc for this email summary.
    $scope.bccStatuses = []

    # An array of objects with all charts for this user and whether they have been selected as a chart
    # for this email summary.
    $scope.chartStatuses = []

    $scope.baseUrl = $url('')

    # Move bcc's back into the emailSummary.bcc field for sending.
    _updateEmailSummaryBccs = ->
      selectedBccStatuses = _($scope.bccStatuses).filter (bccStatus) ->
        bccStatus.selected == true

      $scope.emailSummary.bcc = _(selectedBccStatuses).pluck 'bcc'

    # Move chart id's back into emailSuymmary.charts field for sending.
    _updateEmailSummaryCharts = ->
      selectedChartStatuses = _($scope.chartStatuses).filter (chartStatus) ->
        chartStatus.selected == true

      $scope.emailSummary.summaryItems = _(selectedChartStatuses).pluck 'chart'

    _getEmailSummary = ->
      deferred = $q.defer()
      # Do not load anything if there is no email summary to get.
      EmailSummaries.get(parseInt($routeParams.esid))
      .then (successResponse) ->
        $scope.emailSummary = angular.copy successResponse

        # Leave name field blank if duplicate.
        if $scope.esumAction == "duplicate"
          $scope.emailSummary.id = null
          $scope.emailSummary.name = null

        deferred.resolve successResponse
      , (errorResponse) ->
        $scope.errorText = "Uh oh. We're having trouble finding this email summary."
        deferred.reject errorResponse

      return deferred.promise

    # Add emails to bccStatuses, as long as they aren't already added.
    _addBccsFromList = (list) ->

      _(list).each (email) ->
        selected = null
        if _($scope.emailSummary.bcc).find((bccInESum) -> bccInESum == email)?
          selected = true
        else
          selected = false

        unless _($scope.bccStatuses).find((bccStatus) -> bccStatus.bcc == email)?
          $scope.bccStatuses.push {'bcc': email, 'selected': selected}

    # Creates the bccStatus list from user emails and bcc's from
    # other emailSummaries created by this user.
    _getBccs = ->
      # First, add all email currently added to bcc's
      EmailSummaries.getBccs()
      .then (successResponse) ->
        # All bcc's for this user's email summaries
        bccList = successResponse
        # Add all bcc'd emails from the list.
        _addBccsFromList(bccList)

    # Get the charts and add them to chartStatuses, along with whether they are already selected
    # for this email summary.
    _getCharts = ->
      Charts.getCharts()
      .then (successResponse) ->
        $scope.loadingCharts = false
        _(successResponse).each (chart) ->
          selected = null
          if _($scope.emailSummary.summaryItems).find((chartInESum) -> chartInESum.chartId is chart.chartId or chartInESum.figureId is chart.figureId)?
            selected = true
          else
            selected = false
          $scope.chartStatuses.push {'chart': chart, 'selected': selected}
      , (errorResponse) ->
        $scope.loadingCharts = false
        $scope.errorText= "Oh no! Something went wrong and we can't find your charts."

    $scope.initialize = ->
      $scope.loadingCharts = true
      if $scope.esumAction == "create"
        $scope.emailSummary = {}
        _getCharts()
        _getBccs()
      else
        _getEmailSummary()
        .then (successResponse) ->
          _getCharts()
          _getBccs()
        # necessary to catch any errors for angular 1.6
        # the error is actually handled in _getEmailSummary
        .catch () ->

    $scope.addChartToEmailSummary = ->
      _($scope.chartStatuses).each (chartStatus) ->
        # option values can only be strings, so we need to convert
        # to Int.
        unless chartStatus.chart.chartId?
          if chartStatus.chart.figureId is parseInt($scope.newChartAddedId)
            chartStatus.selected = true
        else if chartStatus.chart.chartId is parseInt($scope.newChartAddedId)
          chartStatus.selected = true

      $scope.newChartAddedId = ""

    $scope.removeChartFromEmailSummary = (chid) ->
      _($scope.chartStatuses).each (chartStatus) ->
        unless chartStatus.chart.chartId?
          if chartStatus.chart.figureId is parseInt(chid)
            chartStatus.selected = false
        else if chartStatus.chart.chartId is parseInt(chid)
          chartStatus.selected = false

    # create new email summary
    $scope.createEmailSummary = ->
      _updateEmailSummaryBccs()
      _updateEmailSummaryCharts()

      EmailSummaries.create($scope.emailSummary)
      .then (successResponse) ->
        $location.path appRoute("/settings/emailsummary/")
      , (errorResponse) ->
        $scope.errorText = "Oh no! We couldn't save this email summary at this time. Try again later."

    # Save existing email summary
    $scope.saveEmailSummary = () ->
      _updateEmailSummaryBccs()
      _updateEmailSummaryCharts()

      EmailSummaries.save($scope.emailSummary)
      .then (successResponse) ->
        $location.path appRoute("/settings/emailsummary/")
      , (errorResponse) ->
        $scope.errorText = "Drat. We're having trouble saving this email summary. Try again later."

    # Wrapper for EmailSummariesService test, with some error handling.
    $scope.sendTest = (sendTo) ->
      EmailSummaries.sendTest($scope.emailSummary.id, sendTo)
      .then (successResponse) ->
          $scope.successText = "The email summary test is queued and will be sent shortly!"
      , (error) ->
          $scope.errorText = "Uh oh! It looks like we couldn't send an email summary test at this time."

    $scope.initialize()
  ]
)
